import styles from './recipe-grid-base.module.scss';

export const RecipeGridBase = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.grid}>{children}</div>;
};
